import SiteImportStepper from '../components/import/SiteImportStepper';

const SiteImportPage = () => {
  return (
    <div className="p-6">
      <SiteImportStepper />
    </div>
  );
};

export default SiteImportPage;
